import { useEffect, useState } from 'react'

interface IProps {
  contentArr: Array<{
    key: string
    value: string
  }>
}
function RenderKeyValue(props: IProps) {
  const { contentArr } = props
  const [arr, setArr] = useState(contentArr)
  const prefix = 'render-box'
  useEffect(() => {
    setArr(contentArr)
  }, [contentArr])
  const renderContentLi = () => {
    return arr.map((item, index) => {
      return <li className={`${prefix}-item`} key={index}>
        <span className={`${prefix}-item-key`}>{item.key}</span>
        <span className={`${prefix}-item-value`}>{item.value}</span>
      </li>
    })
  }
  return <>
    {renderContentLi()}
  </>
}

export default RenderKeyValue
